<template>
  <Card title="企业采购">
    <div class="trade" v-if="purchaseAuthority">
      <div class="clearfix order">
        <div class="left">
          <div class="f16 title">企业订单</div>
          <ul class="ul-cls order-list">
            <li @click="open('v/order/list?appid=1&tabId=1&isShowTitle=1', '待支付-企业订单')">
              <el-badge :value="orderNums.dzfOrderNum" :max="99" :hidden="!orderNums.dzfOrderNum || orderNums.dzfOrderNum === 0">
                <a> <svg-icon icon-class="待支付" /> </a>
              </el-badge>
              <a>待支付</a>
            </li>
            <li @click="open('v/order/list?appid=1&tabId=2&isShowTitle=1', '待发货-企业订单')">
              <el-badge :value="orderNums.orderStatus2" :max="99" :hidden="!orderNums.orderStatus2 || orderNums.orderStatus2 === 0">
                <a> <svg-icon icon-class="待发货" /></a>
              </el-badge>
              <a>待发货</a>
            </li>
            <li @click="open('v/order/list?appid=1&tabId=3&isShowTitle=1', '待收货-企业订单')">
              <el-badge :value="orderNums.orderStatus3" :max="99" :hidden="!orderNums.orderStatus3 || orderNums.orderStatus3 === 0">
                <a> <svg-icon icon-class="待收货" /> </a>
              </el-badge>
              <a>待收货</a>
            </li>
            <li @click="open('v/order/list?appid=1&tabId=4&isShowTitle=1', '待评价-企业订单')">
              <el-badge :value="orderNums.orderStatus4" :max="99" :hidden="!orderNums.orderStatus4 || orderNums.orderStatus4 === 0">
                <a> <svg-icon icon-class="待评价" /> </a>
              </el-badge>
              <a>待评价</a>
            </li>
            <li @click="open('v/aftersales/orderList?appid=1&isShowTitle=1', '售后-企业订单')">
              <el-badge :value="orderNums.refundStatusCount" :max="99" :hidden="!orderNums.refundStatusCount || orderNums.refundStatusCount === 0">
                <a> <svg-icon icon-class="售后" /></a>
              </el-badge>
              <a>售后</a>
            </li>
            <li @click="open('v/order/list?appid=1&tabId=0&isShowTitle=1', '企业订单')">
              <a> <svg-icon icon-class="全部订单" /> </a>
              <a>全部订单</a>
            </li>
            <li @click="open('cart/selectCart.do?appid=1', '进货车', 1)">
              <el-badge :value="shoppingNum" :max="99" :hidden="shoppingNum == 0">
                <a> <svg-icon icon-class="购物车2" /></a>
              </el-badge>
              <a>进货车</a>
            </li>
          </ul>
        </div>
        <div class="right">
          <!-- 优选好物 -->
          <div class="clearfix">
            <!-- favorite-class -->
            <ul class="ul-cls f16 pointer pull-left">
              <li :class="{ active: favoriteClass === 1 }">
                <template v-if="favorite.shopNums === 0">推荐店铺</template>
                <template v-else>关注店铺 [{{ favorite.shopNums }}]</template>
              </li>
            </ul>
            <template v-if="favoriteClass === 0">
              <a target="_blank" :href="origin.VUE_APP_APP" v-if="favorite.goodsNums === 0" class="pull-right blue more">更多 ></a>
            </template>
            <template v-else>
              <a target="_blank" :href="`${origin.VUE_APP_APP}goods/toShopList.do`" v-if="favorite.goodsNums === 0" class="pull-right blue more">更多 ></a>
            </template>
          </div>
          <div class="favorite-list" v-if="favoriteClass === 0">
            <div class="text-center item" v-for="item in goodList" :key="item.goodsId || item.goodsEntity.goodsId">
              <a :href="`${goodDetailUrl}${item.goodsId}`" target="_blank">
                <img :title="item.goodsName" :src="`${item.goodsUrl}?imageView2/1/w/90/h/90`" v-if="item.goodsUrl" />
                <img v-else src="./images/goods.png" :title="item.goodsName" />
              </a>
              <a :href="`${goodDetailUrl}${item.goodsId}`" class="text-left text-overflow-2 text" target="_blank" :title="item.goodsName">{{
                item.goodsName
              }}</a>
            </div>
          </div>

          <!-- 推荐店铺 -->
          <div class="favorite-list" v-else>
            <div class="text-center item pointer" v-for="item in favorite.shopList" :key="item.shopIds || item.shopEntity.shopIdStr" @click="openLink(item)">
              <template v-if="item.shopIds">
                <a>
                  <img :title="item.name" :src="`${item.face}?imageView2/1/w/90/h/90`" v-if="item.face" style="height: 90px" />
                  <img :title="item.name" src="./images/shop.png" v-else style="height: 90px" />
                </a>
                <a class="text-overflow-2 text" :title="item.name">{{ item.name }}</a>
              </template>
            </div>
          </div>
        </div>
      </div>
      <goodList></goodList>
    </div>
    <div class="pad50-tb text-center f16" v-else>
      <i class="el-icon-warning-outline mar10-r"></i>
      <span>抱歉，您没有查看权限。若需要查看请联系公司管理员分配权限</span>
    </div>
  </Card>
</template>

<style lang="scss" scoped>
@import "./style.scss";
</style>

<script>
import { message } from "element-ui";
import { mapState } from "vuex";
import Card from "@/components/Card";
import goodList from "./goodList";

export default {
  name: "MyInfo",
  data() {
    return {
      origin: process.env,
      orderNums: {},
      // 优选好物
      goodList: [],
      shopList: [],
      dataList: [],
      // 我的收藏
      favorite: {
        shopNums: 0,
        shopList: [],
        goodsNums: 0,
        goodList: [],
      },
      // 我的收藏类别：0收藏货品、1关注店铺
      favoriteClass: 1,
      // 货品详情地址
      goodDetailUrl: `${process.env.VUE_APP_APP}goods/queryGoodsDetailInfo/`,
      // 店铺详情地址
      shopDetailUrl: `${process.env.VUE_APP_APP}shopIndex/toShopIndex.do?shopId=`,
      // 楼层名称
      floorNameList: [],
      // 楼层商品
      floorGoodsList: [],
      shoppingNum: 0,
    };
  },
  components: {
    goodList,
    Card,
  },
  computed: mapState({
    userIdentity: (state) => state.app.userIdentity,
    purchaseAuthority: (state) => state.app.purchaseAuthority,
  }),
  created() {
    const { cardId } = this.$route.query;

    if (this.purchaseAuthority) {
      window.parent.postMessage({ fn: "setCardHeight", data: { cardId, height: 910 } }, "*");
      // 查询用户进货车商品数量与商品总金额
      this.$store.dispatch("trade/shoppingCart").then((data) => {
        if (data.cartCount > 99) {
          this.shoppingNum = "99+";
        } else {
          this.shoppingNum = data.cartCount;
        }
      });

      // 获取订单
      this.$store.dispatch("trade/orderNumsList").then((data) => {
        this.orderNums = data || {};
      });

      const { ID, Type } = this.userIdentity;
      this.$store
        .dispatch("trade/getRecommendHotList", {
          use_customer: 1,
          use_favorite: 1,
          in_business_id: ID,
          in_business_type: Type === 0 ? 2 : 1,
          out_business_type: 7,
          tracking_code: "pc_home_member_accurate",
          page: 1,
          page_size: 6,
        })
        .then((shopList2) => {
          if (shopList2) {
            this.favorite = {
              ...this.favorite,
              shopList: shopList2,
            };
          }
        });
    } else {
      window.parent.postMessage({ fn: "setCardHeight", data: { cardId, height: 170 } }, "*");
    }
  },
  methods: {
    open(url, title, type) {
      const target = type ? type : 0;
      const homeUrl = `${this.origin.VUE_APP_APP}${url}`;
      window.parent.postMessage({ fn: "open", data: { url: homeUrl, title, target } }, "*");
    },
    openLink(item) {
      let link = "";
      if (item.returnType === 1) {
        // eslint-disable-next-line
        link = `${this.origin.VUE_APP_APP}recommend/page.do?shopId=${item.shopIds}&tracking_code=pc_home_member_accurate`;
      } else {
        link = `${this.origin.VUE_APP_APP}shopIndex/toShopIndex.do?shopId=${item.shopIds}`;
      }
      window.parent.postMessage({ fn: "open", data: { url: link, title: "推荐店铺", target: 1 } }, "*");
      // $open({ url: link, title: "推荐店铺", target: 1 });
    },
    // 加入购物车
    addToCarts(item) {
      this.$store.dispatch("trade/shoppingCartUpdate", { fromshopid: item.shopIds, goodscount: 1, goodsid: item.goodsId }).then((data) => {
        message(data.msg || "系统繁忙");
      });
    },
  },
};
</script>
